import React from 'react';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import { cloneDeep } from 'lodash';
import SelectFormField from '@components/form-fields/SelectFormField';
import { IAmendmentDetails, IAmendmentPageState } from '..';
import { IAmendmentGeneralData } from '../line-amendment';
import { IAbstractRecord } from '@models';
import DatePickerFormField from '@components/form-fields/DatePickerFormField';

interface IAmendmentDetailsProps {
  generalData: IAmendmentGeneralData;
  lovs: IAbstractRecord;
  pageState: IAmendmentPageState;
  isDisabled: boolean;
  onChange: (pageState: IAmendmentPageState) => void;
}

const AmendmentDetails: React.FC<IAmendmentDetailsProps> = ({
  generalData,
  lovs,
  pageState,
  isDisabled,
  onChange,
}) => {
  const values = pageState.values.amendmentDetails;
  const touched = pageState.touched.amendmentDetails;
  const errors = pageState.errors.amendmentDetails;

  const handleChange = (fieldName: keyof IAmendmentDetails, value: any) => {
    const newState = cloneDeep(pageState);
    newState.values.amendmentDetails[fieldName] = value;
    onChange(newState);
  };

  return (
    <WidgetPaper>
      <WidgetSection title="Amendment Details" isFieldsGrid>
        <DatePickerFormField
          name="amendmentIssueDate"
          title="Amendment Issue Date"
          value={values.amendmentIssueDate}
          error={touched.amendmentIssueDate ? errors.amendmentIssueDate : ''}
          onDateChange={(v) => handleChange('amendmentIssueDate', v)}
          disabled
          material
        />
        <DatePickerFormField
          name="amendmentEffectiveDate"
          title="Amendment Effective Date"
          value={values.amendmentEffectiveDate}
          error={
            touched.amendmentEffectiveDate ? errors.amendmentEffectiveDate : ''
          }
          onDateChange={(v) => handleChange('amendmentEffectiveDate', v)}
          minDate={new Date(generalData.policy.effectiveDate)}
          maxDate={new Date(generalData.policy.expiryDate)}
          material
          disabled={isDisabled}
        />
        <SelectFormField
          key="amendmentType"
          name="amendmentType"
          title="Amendment Type"
          placeholder="Amendment Type"
          value={values.amendmentType}
          error={touched.amendmentType ? errors.amendmentType : ''}
          onChange={(v) => handleChange('amendmentType', v)}
          selectOptions={lovs.amendmentTypes}
          disabled
          material
        />
        <SelectFormField
          key="amendmentSubType"
          name="amendmentSubType"
          title="Amendment Sub-type"
          placeholder="Amendment Sub-type"
          value={values.amendmentSubType}
          error={touched.amendmentSubType ? errors.amendmentSubType : ''}
          onChange={(v) => handleChange('amendmentSubType', v)}
          selectOptions={lovs.amendmentSubTypes}
          material
          disabled={isDisabled}
        />
      </WidgetSection>
    </WidgetPaper>
  );
};

export default AmendmentDetails;
